import React from 'react';

import { Skeleton } from '@material-ui/lab';
import styled from 'styled-components';

const SkeletonLoader = ({
  skeletons = [], // array of numbers, numbers stands for width
}) =>
  skeletons.length > 0 ? (
    <SkeletonContainer>
      {skeletons.map((width, index) => (
        <Skeleton width={width} key={index} />
      ))}
    </SkeletonContainer>
  ) : null;

const SkeletonContainer = styled.div`
  flex: 1;
  padding: 1.5rem 1.5rem;
`;

export default SkeletonLoader;
